import { useEffect, useState } from 'react';

import { IconHamburgerMenu } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { RootState } from '@iwProvider/configureStore';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Dispatch } from 'redux';

import { Filters, FilterDrawer } from './filters';
import styles from './sellerDirectory.module.css';
import { Sellers } from './sellers';
import { useSellerDirectory } from './useSellerDirectory';
import { BreadCrumb } from '../breadCrumbs/breadCrumbs';
import {
    ACTIVATE_IWOCAPAY_DASHBOARD,
    REFRESH_APPLICATIONS,
    SELECT_NEW_PLAN
} from '../dashboard/Dashboard.actions';
import { Plan } from '../dashboard/Dashboard.types';
import { useRefreshSpendingLimits } from '../dashboard/hooks/useRefreshSpendingLimits';
import SpendingLimitCard from '../dashboard/spendingLimitCard/SpendingLimitCard';
import { SpendingLimitDrawer } from '../dashboard/SpendingLimitDrawer/SpendingLimitDrawer';
import { ReferBanner } from '../referBanner/referBanner';

export type Seller = {
    name: string;
    state_key: string;
    category: string;
    website: string;
};

const mapStateToProps = (state: RootState) => state.iwocapayDashboard;

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setSelectedPaymentPlan: (plan: Plan) => {
        dispatch({
            type: SELECT_NEW_PLAN,
            plan
        });
    },
    activate: () => dispatch({ type: ACTIVATE_IWOCAPAY_DASHBOARD }),
    refreshApplications: () => dispatch({ type: REFRESH_APPLICATIONS })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

export const SellerDirecotry = connect(
    mapStateToProps,
    mapDispatchToProps
)(({ activate, iwocaPayApplication, refreshApplications }: PropsFromRedux) => {
    useEffect(() => {
        activate();
    }, [activate]);

    const { sellers, error } = useSellerDirectory();
    const [selectedFilter, setSelectedFilter] = useState<string | null>(null);
    const [filterDrawer, setFilterDrawer] = useState(false);
    const [isSpendingLimitDrawerOpen, setIsSpendingLimitDrawerOpen] =
        useState(false);

    const {
        refreshSpendingLimit,
        isLoading: loadingRefreshSpendingLimit,
        isError: refreshSpendingLimitError
    } = useRefreshSpendingLimits(refreshApplications);

    const handleRefreshSpendingLimit = async () => {
        try {
            await refreshSpendingLimit();
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
            // do nothing
        }
    };

    if (error) {
        return <Redirect to={`/iwocapay/${window.location.search}`} />;
    }

    return (
        <div className={styles.background}>
            <div className={styles.sellerDirectory}>
                <div className={styles.crumbs}>
                    <BreadCrumb url="/iwocapay/">
                        iwocaPay Dashboard{' '}
                    </BreadCrumb>
                    <BreadCrumb final>Supplier directory</BreadCrumb>
                </div>
                <div className={styles.spendingLimit}>
                    <SpendingLimitCard
                        setIsSpendingLimitDrawerOpen={
                            setIsSpendingLimitDrawerOpen
                        }
                        refreshSpendingLimit={handleRefreshSpendingLimit}
                        loadingRefreshSpendingLimit={
                            loadingRefreshSpendingLimit
                        }
                        application={iwocaPayApplication}
                    />
                    <SpendingLimitDrawer
                        isOpen={isSpendingLimitDrawerOpen}
                        setIsOpen={setIsSpendingLimitDrawerOpen}
                        refreshSpendingLimit={handleRefreshSpendingLimit}
                        loadingRefreshSpendingLimit={
                            loadingRefreshSpendingLimit
                        }
                        isError={refreshSpendingLimitError}
                        application={iwocaPayApplication}
                    />
                </div>
                <div className={styles.filters}>
                    <Filters
                        sellers={sellers}
                        selectedFilter={selectedFilter}
                        setSelectedFilter={setSelectedFilter}
                    />
                </div>
                <div className={styles.banner}>
                    <ReferBanner />
                </div>
                <div className={styles.sellers} data-testid="sellers">
                    <Button
                        variant="tertiary"
                        onClick={() => setFilterDrawer(true)}
                        className={styles.filterButton}
                    >
                        <IconHamburgerMenu />
                        Filter by suppliers type
                    </Button>
                    <Sellers sellers={sellers} filter={selectedFilter} />
                </div>
            </div>
            <FilterDrawer
                isOpen={filterDrawer}
                onClose={() => setFilterDrawer(false)}
                sellers={sellers}
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
            />
        </div>
    );
});
